export const ADD_GESTURE = 'ADD_GESTURE'
export const REMOVE_GESTURE = 'REMOVE_GESTURE'
